var map = {
	"./1.webp": 8452,
	"./10-belly piercing_8_11zon.webp": 7377,
	"./10_7_11zon.webp": 3730,
	"./11-dermal piercing_9_11zon.webp": 3479,
	"./11.webp": 1053,
	"./12-eyebrow piercing_11_11zon.webp": 9427,
	"./12_10_11zon.webp": 3574,
	"./13.webp": 986,
	"./14-Cat tattoo.webp": 9783,
	"./14.webp": 2414,
	"./15-Line face work tattoo_14_11zon.webp": 5672,
	"./15-belly piercing_13_11zon.webp": 9920,
	"./16-Mandala lotus tattoo_16_11zon.webp": 5970,
	"./16-belly piercing_15_11zon.webp": 3148,
	"./17-Name tattoos babat name_17_11zon.webp": 1971,
	"./17-nose piercing_18_11zon.webp": 3003,
	"./18-Vidi vini vici tattoo_20_11zon.webp": 9018,
	"./18-nose piercing_19_11zon.webp": 7149,
	"./19-name of baby girl_21_11zon.webp": 3093,
	"./19-septum piercing_22_11zon.webp": 3117,
	"./2.webp": 7334,
	"./20-nike shoes tag nike india in this on insta_23_11zon.webp": 3855,
	"./20-septum piercing_24_11zon.webp": 655,
	"./21-rose and knife tattoo done by artist dheeraj_25_11zon.webp": 7492,
	"./21-septum piercing_26_11zon.webp": 232,
	"./22-runner athlete_27_11zon.webp": 1127,
	"./22-smiley piercing_28_11zon.webp": 9505,
	"./23-tragus piercing_29_11zon.webp": 8749,
	"./23-unalome tattoo related to buddha_30_11zon.webp": 2553,
	"./24-abstract buddha_31_11zon.webp": 454,
	"./24-belly piercing_32_11zon.webp": 7036,
	"./25-abstract butterfly_33_11zon.webp": 5107,
	"./25-conch piercing_34_11zon.webp": 3185,
	"./26-abstract lion_35_11zon.webp": 7146,
	"./26-helix piercing_36_11zon.webp": 7664,
	"./27-ambigram name of daughter and wife, jisha and neha_37_11zon.webp": 2892,
	"./27-helix piercing_38_11zon.webp": 9837,
	"./28-beloved eyes_40_11zon.webp": 9436,
	"./28_39_11zon.webp": 8631,
	"./29-dad with daughters.....start kiya hai pura sleeve banega_42_11zon.webp": 7948,
	"./29_41_11zon.webp": 757,
	"./3-Conch piercing.webp": 4116,
	"./3.webp": 7632,
	"./30-dragonfly unalome tattoo_44_11zon.webp": 9838,
	"./30_43_11zon.webp": 8103,
	"./31-flower with name_46_11zon.webp": 6657,
	"./31_45_11zon.webp": 5233,
	"./32_47_11zon.webp": 5333,
	"./33-karma knot tattoo_49_11zon.webp": 5437,
	"./33_48_11zon.webp": 8549,
	"./34-khanda and nishan sahib tattoo_51_11zon.webp": 3765,
	"./34_50_11zon.webp": 1093,
	"./35-krishna abstract_53_11zon.webp": 1095,
	"./35_52_11zon.webp": 1692,
	"./36-quote on foot_55_11zon.webp": 8066,
	"./36_54_11zon.webp": 7993,
	"./37-semi colon_57_11zon.webp": 7845,
	"./37_56_11zon.webp": 3769,
	"./38-snake tattoo_59_11zon.webp": 2109,
	"./38_58_11zon.webp": 7659,
	"./39-abstract camera tattoo_61_11zon.webp": 4558,
	"./39_60_11zon.webp": 5521,
	"./4-Belly piercing.webp": 9413,
	"./4.webp": 8686,
	"./40-abstract piece of art_63_11zon.webp": 3294,
	"./40_62_11zon.webp": 7033,
	"./41-bad is related to michael jackson_65_11zon.webp": 6018,
	"./41_64_11zon.webp": 2869,
	"./42-butterfly tattoo_66_11zon.webp": 7743,
	"./42-septum piercing_67_11zon.webp": 9434,
	"./43-camera aperture_68_11zon.webp": 408,
	"./43-upper lobe and helix piercing_69_11zon.webp": 7781,
	"./44-camera_70_11zon.webp": 8692,
	"./44-upper lobe piercing_71_11zon.webp": 9547,
	"./45-dad and sun abstract_72_11zon.webp": 315,
	"./45-upper lobe piercing_73_11zon.webp": 1623,
	"./46-death is mystery_74_11zon.webp": 7158,
	"./46-skull piercing jewellery_75_11zon.webp": 6424,
	"./47-guardian angel tattoo_76_11zon.webp": 7589,
	"./47-nose piercing_77_11zon.webp": 1671,
	"./48-in the loving memory of his father, father name short form is gsp_78_11zon.webp": 7770,
	"./49-is in love_79_11zon.webp": 8070,
	"./5-Navel piercing_2_11zon.webp": 8606,
	"./50-maa tattoo_80_11zon.webp": 753,
	"./51-mahadev tattoo done by artist dheeraj_81_11zon.webp": 1897,
	"./52-minimalist tattoo of sun moon with water waves_82_11zon.webp": 776,
	"./53-name tattoo_83_11zon.webp": 4033,
	"./54-name tattoo_84_11zon.webp": 4895,
	"./55-nirvana tattoo_85_11zon.webp": 2682,
	"./56-quote tattoo_86_11zon.webp": 8903,
	"./57-rider tattoo with wings_87_11zon.webp": 174,
	"./5_1_11zon.webp": 8269,
	"./6-nose piercing_6_11zon.webp": 4813,
	"./6_3_11zon.webp": 2544,
	"./7-septum piercing.webp": 818,
	"./7_5_11zon.webp": 5934,
	"./8-rook piercing.webp": 1269,
	"./8.webp": 5562,
	"./9-conch piercing.webp": 5396,
	"./9.webp": 4512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 774;